// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountListPagesLayoutStyles } from "@sc/App/Widgets/Layout/MyAccountListPagesLayout";
import { PaginationStyle } from "@sc/MobiusOverrides/Pagination";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

myAccountListPagesLayoutStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

myAccountListPagesLayoutStyles.tagsContainer = {
    css: css`
        margin-top: 12px;
        &:empty,
        &:has(div:empty) {
            margin-top: 0;
        }
    `,
};

myAccountListPagesLayoutStyles.filtersContainer = {
    css: css`
        margin-top: 12px;
        &:empty,
        &:has(& > div:empty) {
            margin-top: 0;
        }
        ${PaginationStyle} {
            margin: 0;
        }
    `,
};

myAccountListPagesLayoutStyles.tableContainer = {
    css: css`
        margin-top: 20px;
        &:empty,
        &:has(& > div:empty) {
            margin-top: 0;
        }
    `,
};

myAccountListPagesLayoutStyles.splitter = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        margin: 20px 0 0 0;
    `,
};

myAccountListPagesLayoutStyles.bottomPaginationContainer = {
    css: css`
        ${PaginationStyle} {
            ${xScreen("lte", "sm")} {
                > nav:only-child {
                    width: 100%;
                    float: right;
                }
            }
        }
    `,
};
